"use strict";

var bostonFeaturedVenue = {
  slug: "commonwealth",
  name: "Commonwealth",
  url: "http://res.cloudinary.com/dbwijvnzn/image/upload/k70jwvvzrk7bjht2afrt.jpg",
  location: "East Cambridge"
};

var washingtonFeaturedVenue = {
  slug: "charlie-palmer-steak",
  name: "Charlie Palmer Steak",
  url: "http://res.cloudinary.com/dbwijvnzn/image/upload/v1523371978/Charlie_Palmer_-_Landscape_Room_rtkkrp.jpg",
  location: "Capitol Hill"
};

var newyorkFeaturedVenue = {
  slug: "chefs-club",
  name: "Chefs Club",
  url: "http://res.cloudinary.com/dbwijvnzn/image/upload/rvvkadr2r3lxlqm9opsg.jpg",
  location: "SoHo"
};

var losAngelesFeaturedVenue = {
  slug: "cal-mare",
  name: "Cal Mare",
  url: "http://res.cloudinary.com/dbwijvnzn/image/upload/221141_Bar-Lounge_vxlhpd.jpg",
  location: "Central LA"
};

module.exports = {
  bostonFeaturedVenue: bostonFeaturedVenue,
  washingtonFeaturedVenue: washingtonFeaturedVenue,
  newyorkFeaturedVenue: newyorkFeaturedVenue,
  losAngelesFeaturedVenue: losAngelesFeaturedVenue
};